const dialogTriggers = document.querySelectorAll("[data-dialog-trigger]");
const dialogCloses = document.querySelectorAll("[data-dialog-close]");
const html = document.querySelector("html");
const body = document.querySelector("body");
function openDialog(id) {
    const dialog = document.getElementById(id);
    if (dialog) {
        dialog.setAttribute("open", " ");
        html.classList.add("overflow-hidden");
        body.classList.add("overflow-hidden");
    }
}
function closeDialog(id) {
    const dialog = document.getElementById(id);
    if (dialog) {
        dialog.removeAttribute("open");
        html.classList.remove("overflow-hidden");
        body.classList.remove("overflow-hidden");
    }
}
dialogTriggers?.forEach((trigger)=>{
    trigger.addEventListener("click", ()=>openDialog(trigger.getAttribute("data-dialog-trigger")));
});
dialogCloses?.forEach((trigger)=>{
    trigger.addEventListener("click", ()=>closeDialog(trigger.getAttribute("data-dialog-close")));
});

//# sourceMappingURL=index.f9df446b.js.map
